<template>

  <fin-data-loader :resolver="loadData" v-if="!isApp">
    <v-row v-if="changeType === 'DOWNGRADE'">
      <v-col cols="12">
        <div v-if="groupPriceModel && newPriceModel &&
          groupPriceModel.id === 'ADVANCED' && newPriceModel.id === 'EXTENDED'">
          <p>Du hast dich für das <em>{{ newPriceModel.name }}</em> Abo entschieden.
            Wenn du fortfährst, bedeutet das ein Downgrade von deinem derzeitigen Abo <em>{{
                groupPriceModel.name
              }}</em>.
            Nach dem Downgrade wirst du weniger Funktionalitäten zur Verfügung haben.
            Die Anzahl der nutzbaren Portfolios und Watchlists reduziert sich
            <span v-if="newPriceModelNbOfPortfoliosLimit">auf je {{ newPriceModelNbOfPortfoliosLimit }}</span>
            und du wirst das ein oder andere Tool nicht mehr oder nur eingeschränkt verwenden können.</p>
        </div>
        <div v-else-if="newPriceModel.id === 'BASIC'">
          <fin-cancelling-warning v-if="subscriptionCancelledInfos"
                                  :subscription-cancelled-infos="subscriptionCancelledInfos"
                                  @unsubscriptionCancelledInfos="val => updateUnscriptionCancelledInfos(val)"/>
          <p>Du hast das <em>Basic</em> Abo gewählt. Wenn du fortfährst, bedeutet das die Kündigung deines
            derzeitigen Abos <em>{{ groupPriceModel.name }}</em>.</p>
          <p>Das <em>Basic</em> Abo ist kostenfrei und bietet erheblich weniger Funktionalitäten. Die Anzahl der
            nutzbaren Portfolios und Watchlists reduziert sich auf nur je
            eine(s) und du wirst die meisten Tools nicht oder nur eingeschränkt verwenden können.</p>
        </div>

        <div class="mb-12"
             v-if="currentNbOfPortfolios && currentNbOfWatchlists &&
            (currentNbOfPortfolios - newPriceModelNbOfPortfoliosLimit > 0 ||
            currentNbOfWatchlists - newPriceModelNbOfWatchlistsLimit > 0)">
          <p>Derzeit nutzt du:</p>
          <ul class="mb-2">
            <li>
              {{ currentNbOfPortfolios }} Portfolios; damit müsstest du
              {{ currentNbOfPortfolios - newPriceModelNbOfPortfoliosLimit }} Portfolios abgeben.
            </li>
            <li>
              {{ currentNbOfWatchlists }} Watchlists; damit müsstest du
              {{ currentNbOfWatchlists - newPriceModelNbOfWatchlistsLimit }} Watchlists abgeben.
            </li>
          </ul>
          <p>Nachdem der Downgrade aktiv wird, hast du 14 Tage Zeit zu entscheiden, welche der
            Portfolios/Watchlists du behalten willst. Nach den 14 Tagen werden alle inaktiven Portfolios/Watchlists
            automatisch entfernt.</p>
        </div>
        <p style="font-weight: bold">Willst du fortfahren?</p>
        <p>Dann bedanken wir uns für die Nutzung unseres
          {{
            groupPriceModel.id === 'ADVANCED' && newPriceModel.id === 'BASIC' ? 'beliebtesten' : 'leistungsfähigsten'
          }}
          Abos. Wir bedauern, dass du dein Abo kündigen möchtest und würden uns freuen, dich in der Zukunft erneut bei
          uns begrüßen zu dürfen.</p>
      </v-col>
    </v-row>
    <v-row v-else-if="changeType === 'UPGRADE'">
      <v-col cols="12" sm="8" md="9">
        <p style="font-weight: bold">
          Upgrade auf <em>{{ newPriceModel.name }}</em>
        </p>
        <p>
          Willkommen im <em>{{ newPriceModel.name }}</em> Club,
          <span v-if="newPriceModel.id === 'ADVANCED'"> unsere First Class!</span>
          <span v-else-if="newPriceModel.id === 'EXTENDED'"> unsere Business Class!</span>
        </p>
        <p v-if="newPriceModel.id === 'ADVANCED'">
          Mit dem Upgrade auf <em>{{ newPriceModel.name }}</em> bekommst du das volle Programm der finCraft
          Funktionalitäten.
          Jeweils 10 Portfolios und 10 Watchlists unterstützen dich beim Verfolgen des Marktes und deiner Strategien.
          Du bekommst Zugriff auf unsere Musterportfolios, mit denen wir die finCraft Strategien umsetzen und
          stetig verfeinern. Mit 'Bewerte deine Aktie' bekommst du ein weiteres starkes Tool zur Aktienanalyse in die
          Hand.
        </p>
        <p v-else-if="newPriceModel.id === 'EXTENDED'">
          Dieses Upgrade bringt dich ins Cockpit eines Investors.
          Mit dem <em>{{ newPriceModel.name }}</em> Programm kannst du in beiden finCraft Welten unterwegs sein.
          Aktiv als dein eigener Stratege und Analyst mit allen wichtigen Tools zur Suche, Auswahl und
          Erfolgskontrolle deiner Investments. Oder passiv, du lässt dir Portfolios entsprechend deiner
          passenden Strategie(n) vorschlagen und per Monitoring überwachen. Unser Dividenden Service
          macht die Simulation perfekt.
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="3" v-if="$vuetify.breakpoint.smAndUp"
             class="d-flex justify-center align-start">
        <v-img :src="require('@/assets/subscription/upgrade.svg')"
               v-style:maxWidth="$valueByBreakpoint({xs: '80px', sm: '70px', md: '70px', lg: '70px', xl: '100px'})"
               contain/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12"
             class="mt-0 mt-sm-1 d-flex justify-center">
        <fin-price-switcher :price-model="newPriceModel"
                            :switcher-mode="true"
                            class="justify"
                            @changeAboDuration="val => changeAboDuration(val)"/>
      </v-col>
      <v-col cols="12"
             class="d-flex flex-column flex-md-row justify-sm-center justify-md-end">
        <v-btn class="mx-0 mx-sm-1 my-1 my-md-0" outlined @click="abortChangeAbo">Abbrechen</v-btn>
        <v-btn class="mx-0 mx-sm-1 my-1 my-md-0" dark
               :disabled="newPriceModel.id === 'BASIC' && subscriptionCancelledInfos && !unsubscriptionCancelledInfos"
               @click="changeAbo">
          <span v-if="newPriceModel.id !== 'BASIC'">Weiter</span>
          <span v-else>Abo <em>{{ groupPriceModel.name }}</em> kündigen</span>
        </v-btn>
      </v-col>
      <v-col v-if="newPriceModel.id !== 'BASIC' && !hidePromoCodeOffer && promoCodeText && !isApp"
             class="d-flex flex-column flex-md-row justify-sm-center justify-md-end pt-0"
             cols="12">
        <p
          :style="`font-size: 14px;hyphens: none;text-align: center;${$vuetify.breakpoint.mdAndUp ? 'max-width: 200px' : ''}`"
          v-html="promoCodeText"/>
      </v-col>
    </v-row>
  </fin-data-loader>

  <v-row v-else>
    <v-col>
      <p>Auf <a :href="subscriptionWebUrl">fincraft.de</a> findest du weitere Informationen über unser Angebot und
        kannst dein Abo
        verwalten.</p>
    </v-col>
  </v-row>

</template>

<script>
import {mapGetters} from "vuex"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {
  cancelSubscription,
  getPaymentCheckoutLink,
  getPaymentPortalLink
} from "@/components/pages/profile/subscription/graphql"
import FinPriceSwitcher from "@/components/pages/profile/subscription/priceSwitcher"
import finBrowser from "@/js/finBrowser"
import FinDataLoader from "@/components/common/DataLoader"
import FinCancellingWarning from "@/components/pages/profile/subscription/cancellingWarning"
import BaseUrl from "@/mixins/BaseUrl"

const queryListPortfoliosByOwner = /* GraphQL */
  `query listPortfoliosByOwner($owner : String!) {
  listPortfoliosByOwner(owner: $owner, sortDirection: DESC, inclInactive: true) {
    items {
      id
    }
  }
}`
const queryListWatchlistsByOwner = /* GraphQL */ `
query listOwnerWatchlist( $owner : String! ) {
  listOwnerWatchlist(owner: $owner, inclInactive: true) {
      items {
        id
      }
  }
}`


export default {
  name: "FinSubscriptionChange",
  components: {FinCancellingWarning, FinDataLoader, FinPriceSwitcher},
  props: {
    newPriceModel: {
      type: Object,
      default: null,
    },
    aboDuration: {
      type: String
    }
  },
  data() {
    return {
      yearAboVal: this.aboDuration === '1Y',
      isApp: finBrowser.IS_IOS_OR_ANDROID_APP,
      changeType: undefined,
      newPriceModelNbOfPortfoliosLimit: undefined,
      newPriceModelNbOfWatchlistsLimit: undefined,
      currentPriceModelNbOfPortfoliosLimit: undefined,
      currentPriceModelNbOfWatchlistsLimit: undefined,
      currentNbOfPortfolios: undefined,
      currentNbOfWatchlists: undefined,
      subscriptionCancelledInfos: undefined,
      unsubscriptionCancelledInfos: undefined,
      subscriptionWebUrl: undefined,
      hidePromoCodeOffer: process.env.VUE_APP_HIDE_PROMOCODE_OFFER === 'true',
      promoCodeText: process.env.VUE_APP_PROMOCODE_TEXT_ABO_CHANGE_PAGE,
    }
  },
  mixins: [BaseUrl],
  computed: {
    ...mapGetters('auth', ['userId', 'groupPriceModel']),
  },
  methods: {
    async loadData() {
      this.changeType = this.newPriceModel.order < this.groupPriceModel.order ? 'DOWNGRADE' : 'UPGRADE'
      this.newPriceModelNbOfPortfoliosLimit = this.newPriceModel.permissions.find(i => i.featureId === 'PORTFOLIO')?.limited | 0
      this.newPriceModelNbOfWatchlistsLimit = this.newPriceModel.permissions.find(i => i.featureId === 'WATCHLIST')?.limited | 0
      this.currentPriceModelNbOfPortfoliosLimit = this.groupPriceModel.permissions.find(i => i.featureId === 'PORTFOLIO')?.limited | 0
      this.currentPriceModelNbOfWatchlistsLimit = this.groupPriceModel.permissions.find(i => i.featureId === 'WATCHLIST')?.limited | 0

      const p = {owner: this.userId}
      await API.graphql(graphqlOperation(queryListPortfoliosByOwner, p)).then(res => {
        this.currentNbOfPortfolios = res.data.listPortfoliosByOwner.items.length
      }).catch(e => {
        console.error("Failed to get number of portfolios", queryListPortfoliosByOwner, p, e)
      })

      await API.graphql(graphqlOperation(queryListWatchlistsByOwner, p)).then(res => {
        this.currentNbOfWatchlists = res.data.listOwnerWatchlist.items.length
      }).catch(e => {
        console.error("Failed to get number of watchlists", queryListWatchlistsByOwner, p, e)
      })
    },
    changeAboDuration(val) {
      this.yearAboVal = val
    },
    abortChangeAbo() {
      // if url parameter changeToAboId is set => go back
      // otherwise show abo cards' overview
      if (this.$route.query.changeToAboId) {
        this.$router.back()
      } else {
        this.$emit('cancelChange')
      }
    },
    async cancelCurrentAbo() {
      this.subscriptionCancelledInfos = undefined
      this.unsubscriptionCancelledInfos = undefined

      await API.graphql(graphqlOperation(cancelSubscription)).then(res => {
        console.log("cancelCurrentAbo res", res)
        this.subscriptionCancelledInfos = res.data.cancelSubscription
      }).catch(e => {
        console.error("Failed to cancel subscription", e)
      })
    },

    async doChangeAbo() {
      const newPriceId = this.yearAboVal ? this.newPriceModel.price1YId : this.newPriceModel.priceId

      // if the user has the BASIC abo, it is as if he had no abo at all in stripe
      const hasCurrentlyBasicAbo = this.groupPriceModel.id === 'BASIC'
      const query = hasCurrentlyBasicAbo ? getPaymentCheckoutLink : getPaymentPortalLink
      const params = hasCurrentlyBasicAbo ? {
          priceId: newPriceId,
          cancelUrl: this.subscriptionWebUrl + '?success=false',
          successUrl: this.subscriptionWebUrl + '?success=true'
        }
        : {
          returnUrl: this.subscriptionWebUrl
        }

      console.log("params: ", params)
      if (newPriceId && query) {
        let url = undefined
        try {
          const {data} = await API.graphql(graphqlOperation(query, params))
          url = hasCurrentlyBasicAbo ? data.getPaymentCheckoutLink : data.getPaymentPortalLink
        } catch (e) {
          console.error("failed to call query", query, params, e)
          this.$toasted.global.finToast({
            message: 'Es ist ein technischer Fehler aufgetreten. Bitte versuche es später noch einmal oder wende dich an&nbsp;<a href="mailto:support@fincraft.de">support@fincraft.de</a>.',
            type: 'error'
          })
        }

        if (url) {
          window.open(url, '_self')
        }
      } else {
        console.error("an error occurred. priceId or query undefined", newPriceId, query)
      }
    },
    async changeAbo(aboDuration) {
      const duration = aboDuration ? aboDuration : this.aboDuration

      if (this.newPriceModel.id === 'BASIC') {
        await this.cancelCurrentAbo()
      } else {
        await this.doChangeAbo(duration)
      }

      this.unsubscriptionCancelledInfos = undefined
    },
    updateUnscriptionCancelledInfos(val) {
      this.unsubscriptionCancelledInfos = val
    },
  },
  mounted() {
    this.subscriptionWebUrl = this.getBaseURL() + "/protected/myProfile/subscription"
  }
}
</script>

<style lang="scss" scoped>

</style>
